import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, FormGroupComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
@Component({
  selector: 'mbs-enable-reserve-auth-agreement-modal',
  templateUrl: './enable-reserve-auth-agreement-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ModalComponent, ButtonComponent, FormGroupComponent, CheckboxComponent, ReactiveFormsModule, ModalFooterDirective, I18NextPipe]
})
export class EnableReserveAuthAgreementModalComponent {
  public agreementControl = new FormControl(false);
}
